import { render, staticRenderFns } from "./InformationStatistics.vue?vue&type=template&id=44efed9e&scoped=true&"
import script from "./InformationStatistics.vue?vue&type=script&lang=js&"
export * from "./InformationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./InformationStatistics.vue?vue&type=style&index=0&id=44efed9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44efed9e",
  null
  
)

export default component.exports